export default __webpack_public_path__ + "static/logo-Art_of_science@2x-fe5ad72df9d1e1fa0f2b3cd5dcdd7d23.png";